import React, { useEffect, useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

import NewRefundModal from '~/components/Refund/NewModal';

interface Props {
  open: boolean;
  order: App.Order;
  itemId: string;
  onClose: () => void;
  onRefundClose?: () => void;
  refreshData: () => void;
  skipWarning?: boolean;
}

export default function SubscriptionCancelRefundModal({
  open,
  order,
  itemId,
  onClose,
  onRefundClose,
  refreshData,
  skipWarning = false,
}: Props) {
  const [openRefundModal, setOpenRefundModal] = useState(false);

  useEffect(() => {
    if (open && skipWarning) {
      onClose();
      setOpenRefundModal(true);
    }
  }, [open, skipWarning]);

  const handleProceed = () => {
    onClose();
    setOpenRefundModal(true);
  };

  const handleRefundModalClose = () => {
    setOpenRefundModal(false);
    onRefundClose?.();
  };

  return (
    <>
      <Dialog
        open={open && !skipWarning}
        onClose={onClose}
        aria-labelledby="subscription-refund-warning-title"
        aria-describedby="subscription-refund-warning-description"
      >
        <DialogTitle id="subscription-refund-warning-title">Cancel & refund subscription</DialogTitle>
        <DialogContent>
          <DialogContentText id="subscription-refund-warning-description">
            Warning: by cancelling this membership, the customer will be refunded their subscription amount and will no
            longer have access to benefits.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={onClose}>
            No, don't refund
          </Button>
          <Button variant="contained" onClick={handleProceed}>
            Continue
          </Button>
        </DialogActions>
      </Dialog>

      <NewRefundModal
        show={openRefundModal}
        onHide={handleRefundModalClose}
        refreshData={refreshData}
        order={order}
        itemId={itemId}
        automatic={false}
        itemType="subscription"
        isAfterChangeDate={false}
      />
    </>
  );
}
